import { Button, ButtonContainer } from "./style";
import { ActionButton } from "./action";
import { ActionButtonCancel } from "./actionCancel";

export const OuterButtons = ({
	additional,
	action,
	actionCancel,
	editor,
	inline,
	disabled,
	tooltipInfo,
	noFullHeight,
	...props
}) => {
	if (inline) {
		return null;
	}

	const children = [];

	// eslint-disable-next-line no-restricted-syntax
	for (const button of Array.isArray(additional) ? additional : []) {
		children.push(
			<Button {...button} key={button.key || `.${children.length}`} />
		);
	}

	if (actionCancel) {
		children.push(
			<ActionButtonCancel
				key="actionButtonCancel"
				buttonKey="actionButtonCancel"
				tooltipInfo={tooltipInfo}
				editor={editor}
				{...actionCancel}
			/>
		);
	}

	if (action) {
		children.push(
			<ActionButton
				key={action.label ?? "emergencyKey"}
				disabled={disabled}
				tooltipInfo={tooltipInfo}
				editor={editor}
				noFullHeight={noFullHeight}
				{...action}
			/>
		);
	}

	if (!children.length) {
		return null;
	}

	return <ButtonContainer {...props}>{children}</ButtonContainer>;
};
